<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div class="avatar">
        <div class="l-avatar-wrap pointer">
          <a href="#" @click="showNotifications">
            <span v-if="unreadNotifications" class="notify-badge">
              {{ unreadNotifications }}
            </span>
            <img src="../../assets/img/avatar.png"
                 class="l-avatar profile"
            />
          </a>
        </div>
        <span>{{ user.first_name }}<br />{{ user.last_name }}</span>
        <button type="button" class="btn btn-link text-white"
                @click="logout"
        >
          <i class="fa fa-sign-out text-white" />
        </button>
      </div>
      <ul v-if="permissions && !user.company_setup_step" class="tier-1">
        <li>
          <router-link class="sidebar-item"
                       to="/"
                       @click.native="clickLink"
                       exact
          >
            <div class="mod-icon mod-icon-dashboard" />
            <span class="l-menu-title">Dashboard</span>
          </router-link>
        </li>
        <li>
          <router-link v-if="$_can('leads.index') || $_can('leads.index-own')"
                       class="sidebar-item"
                       @click.native="clickLink"
                       to="/leads"
          >
            <div class="mod-icon mod-icon-leads" />
            <span class="l-menu-title">Leads</span>
          </router-link>
        </li>
        <li>
          <router-link v-if="$_can('jobs.index') || $_can('jobs.index-own')"
                       class="sidebar-item"
                       @click.native="clickLink"
                       to="/jobs"
          >
            <div class="mod-icon mod-icon-jobs" />
            <span class="l-menu-title">Jobs</span>
          </router-link>
        </li>
        <li>
          <router-link
            v-if="$_can('claims.index') || $_can('claims.index-own')"
            class="sidebar-item"
            @click.native="clickLink"
            to="/claims"
          >
            <div class="mod-icon mod-icon-claims" />
            <span class="l-menu-title">Claims</span>
          </router-link>
        </li>
        <div class="tier-2-overlay">
          <div class="tier-2-background-wrap" />
          <li>
            <a href="#" class="sidebar-item sidebar-item-sub">
              <div class="mod-icon mod-icon-main-users" />
              <ul class="tier-2"
                  v-if="$_can('carriers.index')
                    || $_can('companies.index')
                    || $_can('clusters.users.index')
                    || $_can('companies.customers.index')
                    || $_can('carriers.movers.index')
                    || $_can('carriers.trucks.index')"
              >
                <li>
                  <router-link v-if="$_can('companies.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/companies"
                  >
                    <div class="mod-icon mod-icon-companies" />
                    <span class="l-sidebar-menu-title">Companies</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('carriers.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/carriers"
                  >
                    <div class="mod-icon mod-icon-groups" />
                    <span class="l-sidebar-menu-title">Carriers</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('clusters.users.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/users"
                  >
                    <div class="mod-icon mod-icon-sub-users" />
                    <span class="l-sidebar-menu-title">Users</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('companies.customers.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/customers"
                  >
                    <div class="mod-icon mod-icon-customers" />
                    <span class="l-sidebar-menu-title">Customers</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('carriers.movers.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/movers"
                  >
                    <div class="mod-icon mod-icon-movers" />
                    <span class="l-sidebar-menu-title">Movers</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('carriers.trucks.index')"
                               class="sidebar-item"
                               @click.native="clickLink"
                               to="/trucks"
                  >
                    <div class="mod-icon mod-icon-trucks" />
                    <span class="l-sidebar-menu-title">Trucks</span></router-link>
                </li>
              </ul>
            </a>
          </li>
          <li v-if="$_can('job-charges.index') || canAccessPayments">
            <a href="#" class="sidebar-item sidebar-item-sub">
              <div class="mod-icon mod-icon-payments" />
              <ul class="tier-2"
                  v-if="$_can('job-charges.index') || canAccessPayments"
              >
                <router-link v-if="$_can('job-charges.index')"
                             class="sidebar-item"
                             @click.native="clickLink"
                             to="/transactions"
                >
                  <div class="mod-icon mod-icon-transactions" />
                  <span class="l-sidebar-menu-title">Transactions</span></router-link>
                <router-link v-if="canAccessPayments"
                             @click.native="clickLink"
                             class="sidebar-item"
                             to="/settings/payment-gateways"
                >
                  <div class="mod-icon mod-icon-gateways" />
                  <span class="l-sidebar-menu-title">Payment gateways</span>
                </router-link>
              </ul>
            </a>
          </li>
          <li v-if="$_can('leads.follow-up-email-templates.index')
            || $_can('phone-numbers.index')
            || $_can('leads.follow-ups.index')
            || $_can('carriers.roles.index')
            || $_can('companies.domains.index')
            || $_can('companies.configurations.index')"
          >
            <a href="#" class="sidebar-item sidebar-item-sub">
              <div class="mod-icon mod-icon-settings" />
              <ul class="tier-2">
                <li>
                  <a href="#" class="sidebar-item"
                     v-if="$_can('companies.domains.index') || $_can('leads.follow-up-email-templates.index')"
                  >
                    <div class="mod-icon mod-icon-mailing" />
                    <span class="l-sidebar-menu-title">Mailing</span>
                    <div class="overlay-blue" />
                    <ul class="tier-3">
                      <!--                      <li>-->
                      <!--                        <router-link v-if="$_can('companies.domains.index')"-->
                      <!--                                     @click.native="clickLink"-->
                      <!--                                     to="/settings/domains"-->
                      <!--                                     class="sidebar-item"-->
                      <!--                        >-->
                      <!--                          <span class="l-sidebar-menu-title">Company domains</span>-->
                      <!--                        </router-link>-->
                      <!--                      </li>-->
                      <li>
                        <router-link
                          @click.native="clickLink"
                          to="/settings/smtp-servers"
                          class="sidebar-item"
                        >
                          <span class="l-sidebar-menu-title">SMTP servers</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link v-if="$_can('leads.follow-up-email-templates.index')"
                                     @click.native="clickLink"
                                     to="/settings/follow-up-templates"
                                     class="sidebar-item"
                        >
                          <span class="l-sidebar-menu-title">Follow up templates</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link v-if="$_can('claims.email-templates.index')"
                                     @click.native="clickLink"
                                     to="/settings/claim-templates"
                                     class="sidebar-item"
                        >
                          <span class="l-sidebar-menu-title">Claim emails</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link v-if="$_can('claims.acknowledgement-email-templates.index')"
                                     @click.native="clickLink"
                                     to="/settings/acknowledgement-templates"
                                     class="sidebar-item"
                        >
                          <span class="l-sidebar-menu-title">Acknowledgement emails</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link v-if="$_can('claims.settlement-email-templates.index')"
                                     @click.native="clickLink"
                                     to="/settings/settlement-templates"
                                     class="sidebar-item"
                        >
                          <span class="l-sidebar-menu-title">Settlement emails</span>
                        </router-link>
                      </li>
                    </ul>
                  </a>
                </li>
                <li>
                  <router-link v-if="$_can('carriers.roles.index')"
                               @click.native="clickLink"
                               class="sidebar-item"
                               to="/settings/user-roles"
                  >
                    <div class="mod-icon mod-icon-user-roles" />
                    <span class="l-sidebar-menu-title">User roles</span>
                  </router-link>
                </li>
                <li>
                  <router-link v-if="$_can('phone-numbers.index')"
                               @click.native="clickLink"
                               class="sidebar-item"
                               to="/settings/phone-numbers"
                  >
                    <div class="mod-icon mod-icon-phone-numbers" />
                    <span class="l-sidebar-menu-title">Phone Numbers</span>
                  </router-link>
                </li>
                <li>
                  <a href="#" class="sidebar-item">
                    <div class="mod-icon mod-icon-messages" />
                    <span class="l-sidebar-menu-title">Messages</span>
                    <ul class="tier-3">
                      <li>
                        <router-link v-if="$_can('settings.messages.index-all') || $_can('settings.messages.index-own')"
                                     @click.native="clickLink"
                                     class="sidebar-item"
                                     to="/settings/messages"
                        >
                          <span class="l-sidebar-menu-title">Customer Messages</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link v-if="$_can('carriers.movers.get-text-message-threads')"
                                     @click.native="clickLink"
                                     class="sidebar-item"
                                     to="/settings/mover-messages"
                        >
                          <span class="l-sidebar-menu-title">Mover Messages</span>
                        </router-link>
                      </li>
                    </ul>
                  </a>
                </li>
                <li v-if="$_can('companies.configurations.index')">
                  <router-link class="sidebar-item"
                               @click.native="clickLink"
                               to="/rates"
                  >
                    <div class="mod-icon mod-icon-rates" />
                    <span class="l-sidebar-menu-title">Rates</span></router-link>
                </li>
                <li>
                  <router-link v-if="$_can('claims.types.index')"
                               @click.native="clickLink"
                               class="sidebar-item"
                               to="/settings/claim-types"
                  >
                    <div class="mod-icon mod-icon-user-roles" />
                    <span class="l-sidebar-menu-title">Claim Types</span>
                  </router-link>
                </li>
                <li>
                  <router-link @click.native="clickLink"
                               class="sidebar-item"
                               to="/contracts"
                  >
                    <div class="mod-icon mod-icon-contracts" />
                    <span class="l-sidebar-menu-title">Contracts</span>
                  </router-link>
                </li>
                <li>
                  <router-link class="sidebar-item"
                               @click.native="clickLink"
                               to="/settings/tags"
                               v-if="$_can('tags.show')"
                  >
                    <div class="mod-icon mod-icon-tags" />
                    <span class="l-sidebar-menu-title">Tags</span></router-link>
                </li>
                <li>
                  <router-link class="sidebar-item"
                               @click.native="clickLink"
                               to="/settings/filters"
                  >
                    <div class="mod-icon mod-icon-filters" />
                    <span class="l-sidebar-menu-title">Filters</span></router-link>
                </li>
              </ul>
            </a>
          </li>
          <li @click.native="clickLink"
              v-if="$_can('clusters.totals.index') || $_can('movers.wages.index')"
          >
            <a href="#" class="sidebar-item sidebar-item-sub">
              <div class="mod-icon mod-icon-reports" />
              <ul class="tier-2" v-if="$_can('clusters.totals.index') || $_can('movers.wages.index')">
                <li>
                  <router-link v-if="$_can('clusters.totals.index')"
                               @click.native="clickLink"
                               to="/reports/totals"
                               class="sidebar-item"
                  >
                    <div class="mod-icon mod-icon-totals" />
                    <span class="l-sidebar-menu-title">Totals</span>
                  </router-link>
                </li>
                <li>
                  <router-link v-if="$_can('movers.wages.index')"
                               @click.native="clickLink"
                               to="/reports/mover-totals"
                               class="sidebar-item"
                  >
                    <div class="mod-icon mod-icon-money" />
                    <span class="l-sidebar-menu-title">Mover Totals</span>
                  </router-link>
                </li>
                <li>
                  <router-link v-if="$_can('sales.view-totals')"
                               @click.native="clickLink"
                               to="/reports/sales"
                               class="sidebar-item"
                  >
                    <div class="mod-icon mod-icon-money" />
                    <span class="l-sidebar-menu-title">Sales Totals</span>
                  </router-link>
                </li>
                <li>
                  <router-link v-if="$_can('job-discounts.index')"
                               @click.native="clickLink"
                               to="/reports/discounts"
                               class="sidebar-item"
                  >
                    <div class="mod-icon mod-icon-money" />
                    <span class="l-sidebar-menu-title">Discounts</span>
                  </router-link>
                </li>
                <li>
                  <router-link @click.native="clickLink"
                               to="/reports/ratings"
                               class="sidebar-item"
                  >
                    <i class="mod-icon fa fa-star text-white" />
                    <span class="l-sidebar-menu-title">Ratings</span>
                  </router-link>
                </li>
              </ul>
            </a>
          </li>
        </div>
        <li>
          <a class="sidebar-item" href="https://docs.mod24.com/mod24/" target="_blank">
            <div class="mod-icon mod-icon-help" />
            <span class="l-menu-title">Help</span>
          </a>
        </li>
        <li>
          <router-link class="sidebar-item logo"
                       to="/"
          />
        </li>
      </ul>
      <ul v-if="user.company_setup_step" class="tier-1 help">
        <li>
          <a class="sidebar-item" href="https://docs.mod24.com/mod24/" target="_blank">
            <div class="mod-icon mod-icon-help" />
            <span class="l-menu-title">Help</span>
          </a>
        </li>
        <li>
          <router-link class="sidebar-item logo"
                       to="/"
          />
        </li>
      </ul>
    </nav>

    <!-- Mobile menu   -->
    <nav class="mobile navbar navbar-light navbar-1">
      <div class="d-flex align-items-center menu-item-wrapper">
        <button class="navbar-toggler" @click="toggleMenu">
          <i class="fa fa-bars hamburger-icon" />
        </button>

        <svg width="48" height="17" viewBox="0 0 48 17" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <rect width="48" height="17" fill="url(#pattern0)" />
          <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0" transform="scale(0.00714286 0.0196078)" />
            </pattern>
            <image id="image0" width="140" height="51" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAAzCAYAAABFXOCeAAAABGdBTUEAALGPC/xhBQAABA1pQ0NQSUNDIFByb2ZpbGUAADiNjVVdaBxVFD67c2cjJM5TbDSFdKg/DSUNk1Y0obS6f93dNm6WSTbaIuhk9u7OmMnOODO7/aFPRVB8MeqbFMS/t4AgKPUP2z60L5UKJdrUICg+tPiDUOiLpuuZOzOZabqx3mXufPOd75577rln7wXouapYlpEUARaari0XMuJzh4+IPSuQhIegFwahV1EdK12pTAI2Twt3tVvfQ8J7X9nV3f6frbdGHRUgcR9is+aoC4iPAfCnVct2AXr6kR8/6loe9mLotzFAxC96uOFj18NzPn6NaWbkLOLTiAVVU2qIlxCPzMX4Rgz7MbDWX6BNauuq6OWiYpt13aCxcO9h/p9twWiF823Dp8+Znz6E72Fc+ys1JefhUcRLqpKfRvwI4mttfbYc4NuWm5ERPwaQ3N6ar6YR70RcrNsHqr6fpK21iiF+54Q28yziLYjPN+fKU8HYq6qTxZzBdsS3NVry8jsEwIm6W5rxx3L7bVOe8ufl6jWay3t5RPz6vHlI9n1ynznt6Xzo84SWLQf8pZeUgxXEg4h/oUZB9ufi/rHcShADGWoa5Ul/LpKjDlsv411tpujPSwwXN9QfSxbr+oFSoP9Es4tygK9ZBqtRjI1P2i256uv5UcXOF3yffIU2q4F/vg2zCQUomDCHvQpNWAMRZChABt8W2Gipgw4GMhStFBmKX6FmFxvnwDzyOrSZzcG+wpT+yMhfg/m4zrQqZIc+ghayGvyOrBbTZfGrhVxjEz9+LDcCPyYZIBLZg89eMkn2kXEyASJ5ijxN9pMcshNk7/rYSmxFXjw31v28jDNSpptF3Tm0u6Bg/zMqTFxT16wsDraGI8sp+wVdvfzGX7Fc6Sw3UbbiGZ26V875X/nr/DL2K/xqpOB/5Ffxt3LHWsy7skzD7GxYc3dVGm0G4xbw0ZnFicUd83Hx5FcPRn6WyZnnr/RdPFlvLg5GrJcF+mr5VhlOjUSs9IP0h7QsvSd9KP3Gvc19yn3Nfc59wV0CkTvLneO+4S5wH3NfxvZq8xpa33sWeRi3Z+mWa6xKISNsFR4WcsI24VFhMvInDAhjQlHYgZat6/sWny+ePR0OYx/mp/tcvi5WAYn7sQL0Tf5VVVTpcJQpHVZvTTi+QROMJENkjJQ2VPe4V/OhIpVP5VJpEFM7UxOpsdRBD4ezpnagbQL7/B3VqW6yUurSY959AlnTOm7rDc0Vd0vSk2IarzYqlprq6IioGIbITI5oU4fabVobBe/e9I/0mzK7DxNbLkec+wzAvj/x7Psu4o60AJYcgIHHI24Yz8oH3gU484TastvBHZFIfAvg1Pfs9r/6Mnh+/dTp3MRzrOctgLU3O52/3+901j5A/6sAZ41/AaCffFVQYP5vAAANZ0lEQVR4Ae2bC7Bd0xmAkyBBIt6SeCUiolQ9ik7rUURHPOIxnWrrVYY2VTVKDY0OU9POoB6tUpMSymgnqlWCek4lYiQaRqhKPBJJhEgIESIhJG6/7+Tsk733Weuce+95JOOef+a7a61/rfWvdf7977XXftzu3VrS8kDKA21tbd0pngSDYWWxal3Sf3fv3n1SsdxKWh5Y5QEDBsaDsrKI+VG2MHJa0vJA3gM9iooktejK0y2tsNySlgf0QFvMDa2AiXmmpQ96oBUwQbfUpuR630Nqs7J29u7UHgZn9OTn7Ai7wA7QDzaB9WAFfAhvw1yYBq+xw15GWjdhDl5TB4JzGAL9YTNYHz6HJfAuvAkvwQzmsIi0rsI8HHcncB7OZ2vYCLpR5xzmgX54GV5lDgtI6yqMsykGkzlsQ34rcA4G7XLwdzvuTNAXrzMPfdRh6VDAMLHtGeFwOBq+Ck6skg1vy96DF+l7P+kDTHQGaacFOwbFMDgOvgEeIIMkJl6PP4AZ9H2E9D54trMOo6+B4Hj7gX44FAaBB6iSfETlHPqOJ3UOk5jDJ5U6VKrDjieMx+AYGA47w8agPiYGjwE8hf73kI5nDh6f+grG+8EoeBlqER12GXgmdkjo0xtOgafgU+isLKTjrbBvhyZAY/p4y3kY3AdLoLPyER3vBW25CnRI6LMXjIF3oLOiDw2c06FPMgHy/sYJkJeLkjYVU3qNgGfyvWssT6f/yVBpdSrNi3Z7w/3wGdRLFmDoYuhbGqhChnbbwA3wIdRLDDptbldh6FIV7frCRfAW1Et81vIglE4g8hMgL5UDhtbrgw6tp4PSk1hO4Q/gMhoV6k+AudAoMRAHRydABfX7w9ONmgB2n4UDq8xhIG3GQaPkDQz7hNff+1hgkELABM9wGm9IvyvhpxqoIG6mXi0yn/Rj6AVugocWcZ8TEjfO58AAxjuTa6m2MoLe8X8LvTMV2cJSirPAzdyb4EZzHdgCdgA3o57BsWv7COr6M9apzGE6+Yygt340bJupyBY+pfg6uLE1dc/k3skbAS+/7i8Ggb85JO5F7mCsHzGHh/IN0Nv/Nvh6vi5Vdjx/v37QH+5NPgP3Vm6E9YM3KqXLD/m0+PtuZKzNSWO+SrdfladDT7gOKolnxAWwD2xWbqUQpRtTtyecBU/ACojJnVRkNo2UR8KyWAf0r8HlcBAYdGV7AXQbwFA4Af4J7h1i4m8yyEtC+VswP9YBvfuhm8HL9iBYr9S5mFFXrDuK1APyNsTEsdzQl4Sydt1rxGQpFa48J8LO4MmeEXTuSzwpvgmXwUyIiT5fHKgMX5Jo+MtA40Q1h8y50C8zoyoF2m8Cp8I0iMn1VBRWPNKjITRp+6q/CoZUGTZTTXtPhMMheU9CtkweR+MZ1o10V4g51g3jX2FfaP/ZuMru3sW+2giJJ8KuxTnot4dCjYq6iaRHgqt6u4X2O8IVEPMxVWVSHjA0ORZiZ/UD1Lk0dlrovy3cBiFZifIMGARzQg3QeXt+SKcnQEf6bwQXQ+x33kSdq+MECMk7KE8CL3udEvvCyRBbbQzqTcGTKCTLUf4GKu7/qk2O/gfAVGiPZAOGHlvC/yI9x6L34VDNgh0309dGxpmNPrYCPE3dl2qeQNEAtgzOpZAXdffA5/kKyl4yagrY9PyxNQzmQUjGoQxdQj9Gf3baTi15bA2GyVBNygLGsy4kj6KsS7AkPwx7veAvocEiupnoa1rdkrHTKTbPg1BghKaxBOWR6f71yGPTvU1770Sd64X1GDdtA5tD4CWoJKsDhlY+mJsRaP0GOnfXdRfsugl7LjBmXvUJimPrPgEMYtcN6R35ASPlSxoxB20y3qjImHn1XShid1o1TQ+7btxDK24yh0zAjEy0ufRnNc2iSmfGOg5im79kKrdWMVNTNYMMhQXJYJH0GfTtesDXmclguw88FRk7Ubt3+nJn7Le3D/bHJIMF0lUBQ8U68GCgwfPoatpUVZso9j3DHwmMnagWk9mjmp1a6xnj8mTAQOpl4IRax6jWnzGOBzf+MbkmZIPGO8JP4CI4BoLv1dD3BE9QL4HBDTv63eA9CEkpYAZS+2agxfmhCdZbx7jeccT2EXdTV/Z8pQFz0FGxfcQL1DX0xPH3OAZMg5C4+d07/7vR7Qezih28c1JugQ0CbY9Ar5//CNFHAdTdCSEpBIwHYx8YkBvAp6eP5XSNKk7E8DsR4+N48vl5pK6e6lcw9lzE4CPMwSe3DZXiGI9GBnke/QvpOo6ox24UDILTwHdBPiU+HQ6CktDWB4reWX0MNzGWT4Vj8kCsQr2DHlpMLSfio2W/nWiG+Lpdh+RlCYqpeWUjyjjQR+hPRmw/E9E3Qh2bw+TiHNNjetBHw0i4nXoD6u+gDF6VlP5+jdxwuKfYrlQRyDyNLnqC+GT1gEAnP3jy+42GC+O4/PkOxx+UloUU5qcVDc77Higvy1G8llc2sDwb28tgw9wYroAZ0W8oXFEKgg/dlyQ+nFFUe6nz8nMWuFKPpuwxb6P/StKQ6HPJX4YLrz1cYXzp5MuzBA3PhWaKL8p0gGe6OIf3wQPWLFkcGEifvBvQN0rlC9jQiap/qskpNPg+eElJr1Tufb4NBpeB9w/4XTGQyJaJ478F/naPRSawjLbe4MFKyyfpQhPynlVKeh7qVhS0zfljwDiePklEZ+m0ZokHKXOAigOn/VI2Fw7+QSivhVfhXFYP9yqJuHdxdfg9eCLadnpxhSKbFVce7P0YrS+V7ecG2tWmsIfSOaEHQa48zRTHc+lMz8UltqKj6jxBA9SDlQ6YxGF1HipqzoNTWPpzLdJzylRxcAejGAMGw+kc8JlJA+p2J+/qMgWegwHgb3Qf0Ie2odWsW9oGbTPS7MDIDL6WFT5kPvnVpBe6/k2c51aMFXpAGJwDB922N4DbipEc6EmkaTmcgp+N7AaTwcuVr3m8TN1M/2ggUh+UDncIWvliKN2rzIOdUz9H/1jOH4hUk7pmfbmaXmUT419JMknKwfZkvxQMivGQvEJxZX6e4JlFOg3GguIK7mba4FoK7mdclTKCXS9Fm8McbORPINb8sFyVsdLgAlM4PzCNSeg8w5sijNUDfEudlz83ZQIMwsB+YxOS6ShdKUpiGfzcQ/kMVkDypPi8UsNUhvqtwVcMT6TUmSx1P4dFMAGuge/B9mDAZa7XmY5drcDZ5FNQr/XH5X77cPTbUf9GTl/XImNsg8FDIkZ3Qn8AlG6jybvnOgdcEdJ7PVce9ysh8W7rNPAZV5kwB2+AjgcvWwcXIel2J5wIHb+G2fsLLI/z27xTSV8WtqZ8MlwOjZSTMO5YIfHS+EMO6MMEbiE4SN28eilqt9DHxxQPVujge6iFoG0vbYlMoW/h8mU0tmS1B6aSDe1XzuZgDV7drL45bA/Eore/lWQElUdUalBrHUHhCvRdOAbugxWwCO6FVcJkQ7I27GH8Cqxpe5iUP04JOQSdL+XSK0/SpaYUm76xHwvtkf/SKLYK1TSPfGfGWRdGwJmZOhQhaXbAXBiYxBR0ayJg3Ez6OWhILs44rw4FBrkkNBA691Qh+RtKH6StGQnNCF2zA2YXxvwB+KmDeJYfBmvkksm4fjPinUde1Pl1XOGOoZYjpg34BSSfJZAtiTq/b5lX0mQzv6pl7HRfzH4HboT2BWF2HqVSUwMm/QPWhjxe8Bb7TyVvZDOe+b7E69fZudoXPEgrISSjtU3FmYFKL9VDOzt20g8bBqzfNCffAd1FfpOkPprSKCRdOmB0Fk7ZDJ4IOaeo8z8sXBXbd2ausunlzhU09t8ZVLVNBG+VnYNfQ14PiRgsbpBLQtm9xhYlRTsz9DFgroS0jKPg0+a4pFun8l0+YPQY/vBfMKp9qG69+5D9YQD0gV7Qs5jvT2qdbZ6FSjKVyszdGOUNwQ33fyATLMU5DkP/ClwHPqvJCLoNYEvYHTKfTVDuC09CWm6nEH8DkG6ZyrcCpuh2fDIEPLOriY/mZ4MfjI+Hx4r52aTWVRM/Ah+SOdqr5+Dnm2VnPjpXoLshkbKn0lR4+ZwFH8Bhefvo/MzTb6eVuTA83yZTLjQr/9MKmJSXcI97Ds+8RslYDPsmuUNCH1eu9H9wnpY3QP2/IJEr8vWWqfw1uNLsFarP6BJLubQVMBkvFZzqXuEMmJHzVS1F/0FPm+vlhqtatA+kV5dFlHfJd0R3KyRiUJQ9S0LXG3wdUFXWyG1r1VmthQ14CroCbmFqh4K3tbNqmOZs+l4Kw7QJ5W+FqxvvSxPvagqP7EnnwhzIywcpxR7ky+6wGH8pvJ9qF83GNzfRLl27Asd6YFzCx5AeCD6u3w+2hcymknIiy8jMg8nwMEzEznzSTgv932MOx2LAsY+C+ejSX9oltpOPpD5FYVD4kvPFpLKjqbdWbYFOVzP4BQF9SxXwAC70TPfuxoPhx069QfG7kwVgsMzCp4tJmyrMbU8GdFUx0F3ZFjKPZFWi2EExYALS2sN00I9dpXmPrvJDW7+zPh5oBUx9/NhlrMQCpuaXa13Gg13sh3qXlL+dMohCu+0u5prWzw15wIA5OFdhwLyd07WKLQ8UPPB/FGPHgqws58MAAAAASUVORK5CYII=" />
          </defs>
        </svg>

        <div class="avatar">
          <div class="l-avatar-wrap pointer">
            <a href="#" @click="showNotifications">
              <span v-if="unreadNotifications" class="notify-badge">
                {{ unreadNotifications }}
              </span>
              <img src="../../assets/img/avatar.png"
                   class="l-avatar profile"
              />
            </a>
          </div>
        </div>
      </div>

      <transition name="slide">
        <div class="r-modal-mask"
             v-if="mobileMenu"
        >
          <MobileSidenav
            :user="user"
            v-scroll-lock="mobileMenu"
            class="mobile-sidebar"
            @close="toggleMenu"
            @clickLink="clickLink"
            @logout="logout"
          />
        </div>
      </transition>
    </nav>

    <transition name="slide-fade">
      <div class="r-modal-mask"
           v-if="notificationsSidebar"
           @click.self="notificationsSidebar = false"
      >
        <notifications
          class="sidebar-left"
          @close="notificationsSidebar = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import tippy from 'tippy.js';
import Notifications from '../Notifications.vue';
import MobileSidenav from './MobileSidenav.vue';

export default {
  name: 'LayoutSidebar',
  components: {
    Notifications,
    MobileSidenav,
  },
  data: () => ({
    notificationsSidebar: false,
    mobileMenu: false,
  }),
  computed: {
    ...mapState({
      user: state => state.auth.dispatchUser,
      unreadNotifications: state => state.auth.unreadNotifications,
    }),
    canAccessPayments() {
      return this.user.roles.some(role => role.id === 1 || role.id === 35);
    },
  },
  methods: {
    ...mapMutations(['setKey', 'setFiltersSaved']),
    ...mapActions(['authLogout', 'getNotifications']),
    mounted() {
      tippy('.popup', {
        placement: 'right',
        html: '#title',
      });
    },
    logout() {
      this.authLogout();
      this.$router.push('/login');
    },
    clickLink() {
      this.setFiltersSaved({});
      this.setKey();
    },
    showNotifications() {
      this.notificationsSidebar = !this.notificationsSidebar;
    },
    toggleMenu() {
      this.mobileMenu = !this.mobileMenu;
    },
  },
};
</script>

<style scoped>
.profile {
  display: inline-block;
}
.notify-badge {
  font-size: 12px;
  position: absolute;
  right: 15px;
  top: 17px;
  background: #3db152;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: white;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutSidebar.vue